import { useEffect } from 'react';
import { dangerous_markComponentAsRoutable } from './routingHelpers';

export const HardRedirect = dangerous_markComponentAsRoutable(
  ({ to, sameHost = true }: { to: string; sameHost?: boolean }) => {
    useEffect(() => {
      const normalizedURL = new URL(to, window.location.origin);

      if (normalizedURL.protocol !== 'https:' && normalizedURL.protocol !== 'http:') {
        // No-op, this usually indicates some sort of script attack
      } else if (!sameHost) {
        window.location.assign(normalizedURL);
      } else if (normalizedURL.host === window.location.host) {
        window.location.assign(normalizedURL);
      } else {
        // No-op, this means HardRedirect expected the sameHost but there was a host mismatch
      }
    }, [to, sameHost]);

    return null;
  },
);
